<table>
    <thead *ngIf="!isSubscriptionModule" class="gridHeading">
        <th *ngIf="allowCheckbox">
            <input type="checkbox" *ngIf="allowSelectAllCheckbox" name="allRows" [checked]="selectAllChecked" [disabled]="selectAllCheckboxDisabled" (click)="selectAllRows($event)" [value]="sampleData" /> <!--(n) from sampledata -->
            <!--<label *ngIf="!allowCheckbox">#</label>-->
        </th>

        <th class="pointer" *ngFor="let column of sampleColumns" 
            [ngStyle]="{width: column.width, minWidth: column.minWidth}">
            <div>
                <span *ngIf="column.name !=='action' && column.name !=='pdfIcon' ">
                    {{column.header || column.name}} 
                    <input class="securityText" id="{{column.name}}" type="text" (keyup)="filterSecurityData($event,column.name)" *ngIf="column.isSearch && column.name !== 'CertificationlevelID'"  /> 
                    <select class="securitySelect" id="{{column.name}}" (change)="filterSecurityData($event,column.name)" *ngIf="column.isSearch && column.name === 'CertificationlevelID'">
                        <option value="">All</option>
                        <option value=1>Client-Certified</option>
                        <option value=2>Not Client-Certified</option>
                    </select>                 
                    <i class="fa fa-sort" *ngIf="(!showAllUsersData && (!sortDir || colName !== column.name)) || (showAllUsersData && (!userSecurityDetailCriteria?.SortOrder || userSecurityDetailCriteria?.SortBy != column.name))" (click)="sortColumn(column.name)" [ngClass]="column.isSearch ? 'fa fa-sort securitySort': 'fa fa-sort'"></i>
              
                    <span  *ngIf="column.name =='FeedbackId'" class="feedbackInfoIcon fa fa-info-circle" title = "The ID that should be provided to participants to complete the post-session feedback survey.">
                    </span>
                </span>
                <span class="far fa my-icon" *ngIf="(!showAllUsersData && (sortDir === -1 && colName === column.name)) || (showAllUsersData && userSecurityDetailCriteria?.SortOrder == 'ASC' && userSecurityDetailCriteria?.SortBy == column.name)" (click)="sortColumn(column.name)" [ngClass]="column.isSearch ? 'far fa my-icon securitySort': 'far fa my-icon'">
                    <i class="fa fa-chevron-down"></i>
                </span>
                <span class="far fa" [ngClass]="column.isSearch ? 'far fa securitySort': 'far fa'" *ngIf="(!showAllUsersData && (sortDir === 1 && colName === column.name)) || (showAllUsersData && userSecurityDetailCriteria?.SortOrder == 'DESC' && userSecurityDetailCriteria?.SortBy == column.name)" (click)="sortColumn(column.name)">
                    <i class="fa fa-chevron-up down-sort-arrow"></i>
                </span>
            </div>
        </th>
    </thead>
    <!-- below code is specific to  Subscription Module-->
    <thead *ngIf="isSubscriptionModule"  class="gridHeading">
        <th class="pointer" *ngFor="let column of sampleColumns" (click)="sortColumn(column.name)" 
            [ngStyle]="{ width: column.width, minWidth: column.minWidth }">
            <div>
                <span *ngIf="column.name !=='action' && column.name !=='pdfIcon' ">
                    {{ column.header || column.name}} <i class="fa fa-sort" *ngIf="!sortDir || colName !== column.name"></i>
                </span>
                <span class="far fa my-icon" *ngIf="sortDir === -1 && colName === column.name">
                    <i class="fa fa-chevron-down"></i>
                </span>
                <span class="far fa" *ngIf="sortDir === 1 && colName === column.name">
                    <i class="fa fa-chevron-up down-sort-arrow"></i>
                </span>
            </div>
        </th>
    </thead>

    <tbody *ngIf="itemsPerPage?.length > 0" class="gridBody">
        <tr *ngFor="let row of itemsPerPage; let i = index" [ngClass]="{ 'dds-data-table__row_selected': row.selected }"
            (click)="toggleRow(row)">
          <td *ngIf="allowCheckbox">
            <input type="checkbox" [disabled]="rowCheckboxDisabled || (selectedRowIndex !== null && selectedRowIndex !== i && isAddSubscriptionModule && LinkType == 'singlelink') || (isAddSubscriptionModule && !row.IsSessionWithinSubsDates)" *ngIf="allowCheckbox"
                   (change)="checkboxClicked($event, row); clickedCheckboxAssessment($event ,row , i)"
                   [checked]="row.checked" [value]="row.checked" />
          </td>
            <!--<td *ngIf="!allowCheckbox">
                {{i+1}}
            </td>-->
        <td *ngFor="let column of sampleColumns ; let idx = index" [ngClass]="{'all-users-data-td': showAllUsersData}">

          <span *ngIf="!iseventRegistered && column.name !== 'Name' && column.name !=='IsActive' && column.name !=='Sessionstatus' && column.name !=='pdfIcon' && column.dataType !=='Email'
                      && column.dataType !=='date' && column.name !=='action' && column.dataType !=='percent' && column.dataType !=='FullName' && column.name !=='SessionName'  &&  column.name !=='SubscriptionuniqeID'
                      && column.name !== 'CertificationlevelID' && column.name !=='IsBC2' && column.name !== 'IsFacilitator' && column.name !== 'IsGXFacilitator' && column.name !== 'IsXANonGX'  && column.name !== 'IsSubscriptionAdmin'  && column.name !== 'IsCountryAdmin'">
              {{ row[column.name] }}
          </span>
          <span *ngIf="((idx == 0 && column.dataType !='FullName') || (column.dataType ==='FullName' && idx ==1) || (column.name ==='SessionName' && idx == 1) ) && iseventRegistered && column.name !=='SubscriptionStatus' && column.name !=='Sessionstatus' ">
              <ng-container *ngIf="column.name === 'SessionName' && isAddSubscriptionModule; else registeredLink">
                  <span>{{ row[column.name] }}</span>
              </ng-container>
              <ng-template #registeredLink>
                  <a [ngClass]="column.name === 'DUNS' || column.name === 'emailCatagory' ? 'non-link-value' : ''" (click)="emitRegisteredEvent(row)">{{ row[column.name] }}</a>
              </ng-template>
          </span>

          <span *ngIf="(idx == 0 && ((column.name ==='SubscriptionStatus' && row[column.name] !='Approval Pending' )|| column.dataType ==='FullName')) ||((idx == 3 || idx == 2 ) && column.name ==='SessionName')  && iseventRegistered " class="reduceWhiteSpace">
            {{ row[column.name] }}
          </span>

          <span *ngIf="(idx == 1 && column.name ==='SubscriptionuniqeID') && iseventRegistered && column.name !=='BCMailBox'">
            <a (click)="navigateToEditPage(row)">{{ row[column.name] }}</a>
          </span>

          <span class="reduceWhiteSpace"
                *ngIf="idx != 0 && iseventRegistered && column.name !=='SubscriptionStatus' && column.name !=='IsActive' && column.name !=='Sessionstatus' && column.name !=='pdfIcon'  && column.dataType !=='Email'
                  && column.dataType !=='date' && column.name !=='action' && column.dataType !=='percent' && column.dataType !=='FullName' && column.name !=='SessionName' && column.name !=='SubscriptionuniqeID'">
            {{ row[column.name] }}
          </span>
          <span *ngIf="column.dataType ==='Email' && column.name !=='BCMailBox'">
            <a (click)="emitEmailClickEvent(row)">{{ row[column.name] }}</a>
          </span>
          <span *ngIf="column.name ==='pdfIcon' && column.name !=='BCMailBox'">
            <a (click)="handlePdfClickValue(row)"><img class="pdfIcon" src="./assets/images/PDF_Icon.svg" alt="PDF" /></a>
          </span>
          <span class="reduceWhiteSpace" *ngIf="column.dataType ==='date'">
            {{row[column.name] | date: 'MM/dd/yyyy'}}
          </span>
          <span class="reduceWhiteSpace" *ngIf="column.dataType ==='percent'">
            {{row[column.name] }} %
          </span>

          <span *ngIf="column.name ==='Name' && showAllUsersData && !iseventRegistered">
            <a (click)="openProfileInfoModal(profileInfoContent, row)">{{ row[column.name] }}</a>
          </span>

          <span *ngIf="column.name ==='Name' && !showAllUsersData && !iseventRegistered">
            {{ row[column.name] }}
          </span>

          <span *ngIf="column.name ==='IsActive' ">
            <input type="checkbox" name="active" [ngClass]="{'isActiveClass': showAllUsersData}" [checked]="row[column.name]"
                   [value]="row[column.name]" (click)="handleActiveCheckboxValue($event,row)" />
          </span>
          <span *ngIf="column.name ==='CertificationlevelID' ">
            <div class="certification-column">
              {{ row[column.name] === 1 ? 'Client-Certified' : 'Not Client-Certified' }}
              <i class="fa fa-solid fa-eye" [ngbPopover]="clientCertifiedContent" placement="bottom" [autoClose]="'outside'" *ngIf="row.CertificationlevelID === 1"></i>
              <ng-template #clientCertifiedContent>
                <div class="certification-date-picker">
                  <input (ngModelChange)="onDateChange($event)"
                         class="form-control" placeholder="mm-dd-yyyy"
                         (click)="d.toggle()" [ngModel]="row.FundamentalCertificationDate | DateToNgb"
                         #certificationDate="ngModel" ngbDatepicker #d="ngbDatepicker"
                         dateFormat="mm-dd-yyyy" [readonly]="true">
                  <div class="input-group-append">
                    <button class="btn btn-outline-secondary calendar"
                            (click)="d.toggle()" type="button">
                      <i class="fa fa-calendar"></i>
                    </button>
                  </div>
                </div>
                <!--{{ row.FundamentalCertificationDate }}-->
              </ng-template>
            </div>
          </span>
          <span *ngIf="column.name ==='IsBC2' ">
            <div class="bc2-column">
              <input type="checkbox" name="bc2" [checked]="row[column.name]" onclick="return false"
                     [value]="row[column.name]" [(ngModel)]="row[column.name]" />
              <i class="fa fa-solid fa-eye" [ngbPopover]="bc2Content" *ngIf="row.IsBC2 === true" placement="bottom" [autoClose]="'outside'"></i>
              <ng-template #bc2Content>
                <table class="bc2-popover" role="presentation">
                  <tr *ngFor="let topic of row.UserTopics; let i=index;">
                    <td>{{ topic.TopicName }}</td>
                    <td>
                      <input type="checkbox" [name]="'bc2_'+i" [disabled]="row.disabled" [checked]="topic.IsActive" readonly
                             [value]="topic.IsActive" [(ngModel)]="topic.IsActive" />
                    </td>
                    <td *ngIf="topic.IsActive">
                      <div class="bc2-column-popover-calender">
                        <input (ngModelChange)="onDateChange($event)"
                               class="form-control" placeholder="mm-dd-yyyy"
                               (click)="d.toggle()" [ngModel]="topic.Date | DateToNgb"
                               #bc2Date="ngModel" ngbDatepicker #d="ngbDatepicker"
                               dateFormat="mm-dd-yyyy" [readonly]="true">
                        <div class="input-group-append">
                          <button class="btn btn-outline-secondary calendar"
                                  (click)="d.toggle()" type="button">
                            <i class="fa fa-calendar"></i>
                          </button>
                        </div>
                      </div>
                      <!--{{ topic.Date }}-->
                    </td>
                  </tr>
                </table>
              </ng-template>
            </div>
          </span>
          <span *ngIf="column.name ==='IsFacilitator' ">
            <input type="checkbox" name="facilitator" [checked]="row[column.name]" onclick="return false"
                   [value]="row[column.name]" [(ngModel)]="row[column.name]" />
          </span>
          <span *ngIf="column.name ==='IsGXFacilitator' ">
            <input type="checkbox" name="gxfacilitator" [checked]="row[column.name]" onclick="return false"
                   [value]="row[column.name]" [(ngModel)]="row[column.name]" />
          </span>
          <span *ngIf="column.name ==='IsXANonGX' ">
            <input type="checkbox" name="xa" [checked]="row[column.name]" onclick="return false"
                   [value]="row[column.name]" [(ngModel)]="row[column.name]" />
          </span>
          <span *ngIf="column.name ==='IsSubscriptionAdmin' ">
            <input type="checkbox" name="subscriptionAdministrator" [checked]="row[column.name]" onclick="return false"
                   [value]="row[column.name]" [(ngModel)]="row[column.name]" />
          </span>
          <span *ngIf="column.name ==='IsCountryAdmin' ">
            <div class="country-administrator-column">
              <input type="checkbox" name="countryAdministrator" [checked]="row[column.name]" onclick="return false"
                     [value]="row[column.name]" [(ngModel)]="row[column.name]" />
              <i class="fa fa-solid fa-eye" [ngbPopover]="countryAdminContent" [popoverClass]="'countryInfo'" placement="bottom" *ngIf="row.IsCountryAdmin === true"></i>
            </div>
            <ng-template #countryAdminContent>{{ row.AssignedCountries }}</ng-template>
          </span>
          <span *ngIf="column.name ==='editEmail'">
            <a href="#" (click)="handleEditClickValue($event,row)"><i class="fa fa-edit"></i></a>
          </span>
          <span *ngIf="column.name ==='editSecurity'">
            <a href="#" disabled="row.IsEditable" class="blackColor" (click)="handleEditClickSecurity($event,row)"><b>Edit</b></a>
          </span>
          <span *ngIf="column.name ==='AssessmentResults'">
            <a role="link" [hidden]="row.SessionLink == '' " [ngClass]='row.AssessmentGivenAllUsersCount == 0 ? "disabledLink" : ""' (click)="redirectToAssessment(row.SessionName)">View Result</a>
          </span>
          <!--//bug fixes-->
          <span *ngIf="column.name ==='Sessionstatus' ">
            <span *ngIf="row[column.name]==='To Review'" class="reviewColor">!</span>
            <span *ngIf="row[column.name]==='Approved'" class="approvedColor">✔</span>
            <span *ngIf="row[column.name]==='Not Approved'" class="notApprovedColor">Ø</span>
            <span *ngIf="row[column.name]==='Cancelled'" class="cancelledColor">X</span>
            <span *ngIf="row[column.name]==='Draft'" class="draftColor">&#9998;</span>
          </span>
          <span *ngIf="column.name ==='SubscriptionStatus' ">
            <span *ngIf="row[column.name]==='Approval Pending'" class="reviewColor">!</span>
          </span>
        </td>
        </tr>
    </tbody>

</table>
<div class="noDataFound" *ngIf="itemsPerPage?.length === 0">{{gridNoResultMsg}}</div>

<!-- Below code is for Pagination -->
<div class="naviMenu" *ngIf="allowPagination && itemsPerPage?.length >= 1 && pages?.length > 1">
    <ul class="pagination">
        <li *ngFor="let page of pages">
            <a [ngClass]="{active:page === currentPage}" *ngIf="page === currentPage"
                href="" (click)="setCurrent($event,page); setPage(page)" class="paginationLink">{{page}}</a>
            <a *ngIf="page !== currentPage" href="" (click)="setCurrent($event,page); setPage(page)">{{page}}</a>
        </li>
    </ul>
</div>

<ng-template #profileInfoContent let-modal>
	<div class="modal-header profile-info-header">
		<h4 class="modal-title" id="modal-basic-title">Profile Info</h4>
		<button type="button" class="btn btn-close" aria-label="Close" (click)="modal.dismiss('Close Modal');closeModal();">
            <i class="fa fa-solid fa-close"></i>
        </button>
	</div>
	<div class="modal-body">
		<div class="modal-profile-info-wrapper">
            <form #profileInfoForm="ngForm" (submit)="profileInfoSubmit(profileInfoForm)">
                <div class="row">
                    <div class="col-md-6 col-sm-6 col-xs-12">
                        <div class="form-group">
                            <label for="mdrName">Name</label>
                                              <input type="text" id="mdrName" name="Name" autocomplete="off" class="form-control" #name="ngModel" [ngModel]="selectedRow.Name" [readOnly]="true">
                        </div>
                    </div>
                    <div class="col-md-6 col-sm-6 col-xs-12">
                        <div class="form-group">
                            <label for="mdrEmail">Email</label>
                                              <input type="text" id="mdrEmail" name="Email" autocomplete="off" class="form-control" #email="ngModel" [ngModel]="selectedRow.Email" [readOnly]="true">
                        </div>
                    </div>
                    <div class="col-md-6 col-sm-6 col-xs-12">
                        <div class="form-group">
                            <label for="mdrCountry">Country/Location</label>
                                              <select name="Country" id="mdrCountry" class="form-control" #country="ngModel" [(ngModel)]="selectedRow.CountryID" [disabled]="disableMdrFields">
                                <option value={{item.ID}} *ngFor="let item  of countries" [attr.selected]="item.ID == selectedRow.CountryID">{{item.Name}}</option>
                            </select>
                        </div>
                    </div>
                    <div class="col-md-6 col-sm-6 col-xs-12">
                        <div class="form-group">
                            <label for="mdrFunction">Function</label>
                                              <select name="ServiceFunction" id="mdrFunction" class="form-control" #serviceFunction="ngModel" [(ngModel)]="selectedRow.ServiceFunctionID" [disabled]="disableMdrFields">
                                <option value={{item.ID}} *ngFor="let item  of functions" [attr.selected]="item.ID == selectedRow.ServiceFunctionID">{{item.Name}}</option>
                            </select>
                        </div>
                    </div>
                    <div class="col-md-6 col-sm-6 col-xs-12">
                        <div class="form-group">
                            <label for="mdrLevel">
                                                Level</label>
                                              <select name="Title" id="mdrLevel" class="form-control" #title="ngModel" [(ngModel)]="selectedRow.LevelID">
                                <option value={{item.ID}} *ngFor="let item  of levels" [attr.selected]="item.ID == selectedRow.LevelID">{{item.Name}}</option>
                                </select>
</div>
                    </div>
                    <div class="col-md-6 col-sm-6 col-xs-12"></div>
                    <div class="col-md-6 col-sm-6 col-xs-12">
                        <div class="form-group">
                            <label>Business Chemistry Certification Level</label>
                            <div class="row form-group">
                                <div class="certification-level-checkbox">
                                    <input class="form-control" #CertificationlevelID="ngModel" [ngModel]="selectedRow.CertificationlevelID" (ngModelChange)="changeToPrevious(fundamentalCertificationDate,selectedRow.CertificationlevelID);checkAuditTrailsData('Client-Certified', $event)"  type="radio" name="CertificationlevelID" id="certificationRadios1" [value]="2">
                                    <label class="form-check-label" for="certificationRadios1">
                                      Not Client-Certified
                                    </label>
                                </div>
                                <div class="certification-level-checkbox">
                                    <input class="form-control" #CertificationlevelID="ngModel" [ngModel]="selectedRow.CertificationlevelID" (ngModelChange)="changeToPrevious(fundamentalCertificationDate,selectedRow.CertificationlevelID);checkAuditTrailsData('Client-Certified', $event)" type="radio" name="CertificationlevelID" id="certificationRadios2" [value]="1">
                                    <label class="form-check-label" for="certificationRadios2">
                                      Client-Certified
                                    </label>
                                </div>
  
                            </div>
                        </div>
                    </div>
                    <div class="col-md-6 col-sm-6 col-xs-12">
                        <div class="form-group">
                            <label for="fundamentalCertificationDateInput">Client Certification Date</label>
                            <div class="fc-date-wrapper">
                                <input class="form-control" id="fundamentalCertificationDateInput" placeholder="mm-dd-yyyy" [maxDate]="maxDate" [required]="(selectedRow.CertificationlevelID == 1) ? 'required': null"
                                    (click)="d.toggle()" #fundamentalCertificationDate="ngModel" [ngModel]="selectedRow.FundamentalCertificationDate | DateToNgb" name="FundamentalCertificationDate"
                                    ngbDatepicker #d="ngbDatepicker" dateFormat="mm-dd-yyyy" [disabled]="selectedRow.CertificationlevelID != 1">
                                <div class="input-group-append">
                                    <button class="btn btn-outline-secondary calendar"
                                        (click)="d.toggle()" type="button" [disabled]="selectedRow.CertificationlevelID != 1">
                                        <i class="fa fa-calendar"></i>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="roleInfoTitle">
                        Role Info
                        <i class="fa fa-info-circle userProfileInfoIcon" title="Uncheck to disable all access to Admin Portal."></i>
                        <input type="checkbox"  [name]="UserRolesCheckbox" (click)="selectAllRoles($event)" [checked]="selectAllRolesCheckbox" [disabled]="!selectedRow.IsFacilitator && !selectedRow.IsGXFacilitator && !selectedRow.IsXANonGX && !selectedRow.IsSubscriptionAdmin && !selectedRow.IsCountryAdmin"/>
                    </div>
                    <div class="col-md-4 col-sm-4 col-xs-12">
                        <div class="form-group">
                            <div class="role-checkbox-wrapper">
                                <label class="role-checkbox-label" for="role1">Facilitator</label>
                                <input type="checkbox" name="IsFacilitator" id="role1" value="true" class="" (ngModelChange)="checkAuditTrailsData('Facilitator', $event);validateMutuallyExclusiveRoles(false,false,true)" #isFacilitator="ngModel" [ngModel]="selectedRow.IsFacilitator">
                            </div>
                        </div>
                    </div>
                    <div class="col-md-4 col-sm-4 col-xs-12" *ngIf="userRoleId === 1">
                        <div class="form-group">
                            <div class="role-checkbox-wrapper">
                                <label class="role-checkbox-label" for="roleIsGXFacilitator">GX Facilitator</label>
                                <input type="checkbox" name="IsGXFacilitator" id="roleIsGXFacilitator" value="false" class="" (ngModelChange)="checkAuditTrailsData('GXFacilitator', $event);validateMutuallyExclusiveRoles(false,true,false)" #isGXFacilitator="ngModel" [ngModel]="selectedRow.IsGXFacilitator">
                            </div>
                        </div>
                    </div>
                    <div class="col-md-4 col-sm-4 col-xs-12" *ngIf="userRoleId === 1">
                        <div class="form-group">
                            <div class="role-checkbox-wrapper">
                                <label class="role-checkbox-label" for="roleIsXANonGX">XA (non-GX)</label>
                                <input type="checkbox" name="IsXANonGX" id="roleIsXANonGX" value="false" class="" (ngModelChange)="checkAuditTrailsData('XA(non GX)', $event);validateMutuallyExclusiveRoles(true,false,false)" #isXANonGX="ngModel" [ngModel]="selectedRow.IsXANonGX">
                            </div>
                        </div>
                    </div>
                    <div class="col-md-4 col-sm-4 col-xs-12">
                        <div class="form-group">
                            <div class="role-checkbox-wrapper">
                                <label class="role-checkbox-label" for="roleIsSubscriptionAdmin">Subscription Admin</label>
                                <input type="checkbox" name="IsSubscriptionAdmin" id="roleIsSubscriptionAdmin" value="false" class="" (ngModelChange)="checkAuditTrailsData('Subscription Admin', $event)" #isSubscriptionAdmin="ngModel" [ngModel]="selectedRow.IsSubscriptionAdmin">
                            </div>
                        </div>
                    </div>
                    <div class="col-md-4 col-sm-4 col-xs-12" *ngIf="userRoleId === 1">
                        <div class="form-group">
                            <div class="role-checkbox-wrapper">
                                <label class="role-checkbox-label" for="roleIsCountryAdmin">Country Admin</label>
                                <input type="checkbox" name="IsCountryAdmin" id="roleIsCountryAdmin" value="true" class="" (ngModelChange)="checkAuditTrailsData('Country Admin', $event)" #isCountryAdmin="ngModel" [ngModel]="selectedRow.IsCountryAdmin" disabled>
                            </div>
                        </div>
                    </div>
                    <span class="countryAdminMessage" *ngIf="userRoleId === 1">
                        Please use the individual role tab to assign country(s) to the Country Administrator. </span>
                </div>
                <div class="row">
                    <div class="bc2InfoTitle">
                        BC 2.0 Info
                        <i class="fa fa-info-circle userProfileInfoIcon" title="Check/Uncheck to enable/disable all BC 2.0 topics."></i>
                        <input type="checkbox" [disabled]="disableTopics" [name]="UserTopicsCheckbox" (click)="selectAllTopics($event)" [checked]="selectAllTopicsCheckbox"/>
                    </div>
                    <div  class="col-md-4 col-sm-4 col-xs-12" *ngFor="let topic of selectedRow.UserTopics; let i=index;">
                        <div class="form-group">
                            <div class="label-checkbox-wrapper">
                                <label class="mr-2" [for]="'UserTopicsCheckbox'+i">{{ topic.TopicName }}</label>
                                <input type="checkbox"  [disabled]="disableTopics" class="topicCheckbox" [checked]="topic.IsActive" [id]="'UserTopicsCheckbox'+i"
                                        [value]="topic.IsActive" (ngModelChange)="checkAuditTrailsData(topic.TopicName, $event, topic)" [(ngModel)]="topic.IsActive" [name]="'UserTopicsCheckbox'+i" />
                            </div>
                            <div class="fc-date-wrapper" *ngIf="(!topic.IsActive && !!topic.IsDateExists) || topic.IsActive">
                                    <input class="form-control" [maxDate]="maxDate" placeholder="mm-dd-yyyy" [required]="(topic.IsActive) ? 'required': null"
                                           (click)="atc.toggle()" #activeTeamChemistryDate="ngModel" [disabled]="!topic.IsActive && !!topic.IsDateExists" (ngModelChange)="bc2InfoDateChange($event, topic)" [ngModel]="topic.Date | DateToNgb" [name]="'UserTopicsDate'+i"
                                    ngbDatepicker #atc="ngbDatepicker" dateFormat="mm-dd-yyyy">
                                    <div class="input-group-append">
                                        <button class="btn btn-outline-secondary calendar"
                                          [disabled]="!topic.IsActive && !!topic.IsDateExists" (click)="atc.toggle()" type="button">
                                            <i class="fa fa-calendar"></i>
                                        </button>
                                    </div>
</div>
                        </div>
                    </div>
                </div>

                <div class="row" *ngIf="auditTrailsAll && auditTrailsAll.length">
                    <div class="auditTrailTitle">Audit Trail</div>
                    <div class="col-md-12 col-sm-12 col-xs-12">
                        <table class="audit-trail-table">
                            <thead>
                                <tr>
                                    <th>Date & Time</th>
                                    <th>Updates</th>
                                    <th>User</th>
                                    <th>Comment</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let item of auditTrailsAll; let i=index">
                                    <td width="110">{{ item.CreatedDate.split(" ")[0] }}<br>{{item.CreatedDate.split(" ")[1].split(":")[0]}}:{{item.CreatedDate.split(" ")[1].split(":")[1]}} {{item.CreatedDate.split(" ")[2]}} CST</td>
                                    <td>{{ item.AuditTrail }}</td>
                                    <td>{{ item.CreatedBy }}</td>
                                    <td width="250" *ngIf="!item.IsNewComent">
                                        <div class="comment-wrapper">    
                                            <div class="comment-list">
                                                <ng-container *ngFor="let commentItem of item.Comments; let j=index">
                                                    <p *ngIf="commentItem.isExistingComment">{{ commentItem.comment }}</p>
                                                    <input type="text" *ngIf="!commentItem.isExistingComment" [name]="'newComment'+i+j" [(ngModel)]="commentItem.comment" />
                                                </ng-container>
                                            </div>  
                                            <span><i class="fa fa-solid fa-plus" (click)="addNewComment(item)"></i></span>
                                        </div>
                                    </td>
                                    <td *ngIf="item.IsNewComent">
                                        <input type="text" [name]="'newComment'+i" [(ngModel)]="item.Comments[0]['comment']" [required]="(!item.IsEnabled) ? 'required': null" />
                                        <span class="comment-error-message" *ngIf="(item.Comments[0]['comment'] === undefined || item.Comments[0]['comment'] === '') && !item.IsEnabled && profileFormSubmitted">Please enter a valid reason</span>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>

                <div class="modal-footer profile-info-footer">
                    <div class="profile-info-footer-add-comment">
                        <!--<button type="button" class="clickBtn">Add New Comment</button>-->
                    </div>
                    <div class="profile-info-footer-actions">
                        <button type="button" class="clickBtn" (click)="modal.dismiss('Close Modal');closeModal();">Cancel</button>
                        <button type="submit" class="clickBtn">Save</button>
                    </div>
                </div>
            </form>
        </div>
	</div>
</ng-template>
